<template>
  <div class="yealuck-2023-top-base">
    <div class="block-hero">
      <h1><img :src="`${imgPath}top/top_image.png`" alt="" class="block-hero_img"></h1>
      <div class="navbtn-block upper" >
        <div class="btn-wrap" :class="{floating: isUppNavFloating}" ref="floater">
          <div
            class="navbtn navbtn-yearluck"
            @click="onNavbtnClick(1)"
          ><img :src="`${imgPath}top/navbtn_yearluck_upper.png`" alt=""></div>
          <div
            class="navbtn navbtn-basicmenus"
            @click="onNavbtnClick(2)"
          ><img :src="`${imgPath}top/navbtn_basicmenus_upper.png`" alt=""></div>
        </div>
      </div>
    </div>

    <div class="block-yearluck-menus" id="block-yearluck-menus">
      <h2><img :src="`${imgPath}top/head_top_yearluck_menus.png`" alt="" class="block-yearluck-menus_img"></h2>
      <div
        class="yearluck-menu-item"
        v-for="(yitem, yidx) in yealuckPackages"
        :key="`y${yidx}`"
        :style="`background-image: url('${yitem.top.pkgBackImg}');`"
        @click="onYearluckItemClick(yitem)"
      >
        <img :src="yitem.top.thumbnail" :alt="yitem.info.name" class="yearluck-menu-item_img">
        <div class="info-box">
          <img :src="yitem.top.pkgTitleImg" :alt="yitem.info.pkgTitle" class="info-box_title">
          <div class="info-area">
            <span class="price-wrap" v-if="!!yitem.server.price">
              <span class="price" v-html="formatPrice(yitem.server.price)"></span>
              <span class="small">（税込）</span>
            </span>
            <span class="price-wrap" v-if="!!yitem.server.member_price">
              <span class="small">会員価格</span>
              <span class="price" v-html="formatPrice(yitem.server.member_price)"></span>
              <span class="small">（税込）</span>
            </span>
            <span class="notice">※一部無料でご覧いただけます</span>
            <span class="link-button" ><img :src="`${imgPath}top/ic_arrow.svg`" alt=""></span>
          </div>
        </div>
      </div>
    </div>

    <div class="block-basic-menus" id="block-basic-menus">
      <h2><img :src="`${imgPath}top/head_top_basic_menus.png`" alt="" class="block-basic-menus_img"></h2>
      <p class="caption">自分を知ると、生きやすくなる！<br>自分や家族、恋人、推し様のタイプを<br>SNSにシェアして友だちと楽しもう💕</p>
      <div
        class="basic-menu-item"
        v-for="(bitem, bidx) in basicMenus"
        :key="`b${bidx}`"
        @click="onBasicMenuItemClick(bitem, bidx)"
      >
        <img :src="bitem.thumbnail" :alt="bitem.title" class="basic-menu-item_thum">
        <div class="menu-title_box">
          <p v-html="bitem.title" class="menu-title_box_text"></p>
          <span class="btn btn-take-free-divination" >無料で占う</span>
        </div>
      </div>
    </div>

    <div class="navbtn-block lower">
      <div class="btn-wrap">
        <div
          class="navbtn navbtn-yearluck"
          @click="onNavbtnClick(1)"
        ><img :src="`${imgPath}top/navbtn_yearluck_lower.png`" alt=""></div>
        <div
          class="navbtn navbtn-basicmenus"
          @click="onNavbtnClick(2)"
        ><img :src="`${imgPath}top/navbtn_basicmenus_lower.png`" alt=""></div>
      </div>
    </div>

    <lp-footer :menu-list="footerMenuList" />
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {PACKAGE_INFO, TOP_FREE_MENUS} from './data/consts'
import { DEFAULT_FOOTER_MENULIST } from '@/utvStore/components/recommend/lp/commons'
import LpFooter from '@/utvStore/components/recommend/lp/blocks/LpFooter'


export default {
  name: 'Yearluck2023Top',
  components: {LpFooter},
  props: {
    receivedPackageInfo: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      imgPath: '/static/img/yearluck/y2023/',
      chkScrFlg : false,
      chkScr: null,
    }
  },
  computed: {
    ...mapState({
      scroll: state => state.uiState.scroll,
    }),
    footerMenuList(){
      return [ ...DEFAULT_FOOTER_MENULIST, ]
    },
    isUppNavFloating() {
      const scr = this.scroll.top
      if(!this.chkScr || !this.chkScr.header || !this.chkScrFlg) {
        this.chkScr = {
          header: document.querySelector('header.header'),
          footer: document.querySelector('.footer'),
          hero: document.querySelector('.block-hero h1'),
        }
        this.chkScrFlg = true

        //再チェック
        if(!this.chkScr.header) return window.scrollY < 500
      }

      if(!!this.chkScr.header) {
        // const bounds = window.innerWidth < 768 ? -6 : -50
        // const bounds = window.innerWidth < 768 ? -20 : -50
        const bounds = -52
        const calc = (this.chkScr.header.clientHeight + this.chkScr.hero.clientHeight)
          - window.innerHeight
          + this.$refs.floater.clientHeight
          + bounds
        const chk = scr < calc
        return chk
      }
    },
    yealuckPackages() {
      return this.receivedPackageInfo.reduce( (acc, item) => {
        const info = PACKAGE_INFO.find(infoitem => infoitem.info.itemId === +item.item_id)
        if(!!info) acc.push({server: item, ...info})
        return acc
      }, [])
    },
    basicMenus() {
      return TOP_FREE_MENUS
    },
  },
  mounted() {
    // console.log('生成したデータ[%O]', this.yealuckPackages)
    // console.log('this.receivedBasicMenus%O', this.receivedBasicMenus)

    window.addEventListener('resize', () => this.chkScrFlg = false)
  },
  methods: {
    formatPrice(val) {
      const price = String(val).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return `￥${price}`
    },
    onNavbtnClick(val) {
      const yearluck = this.$el.querySelector('.block-yearluck-menus')
      const basic = this.$el.querySelector('.block-basic-menus')
      const tgt = val === 1 ? yearluck : basic
      const head = document.querySelector('header.header')
      const offset = 8
      window.scrollTo({top: tgt.getBoundingClientRect().top + window.scrollY - head.clientHeight - offset, behavior: 'smooth'})
    },
    onYearluckItemClick(info) {
      //console.log('onYearluckItemClick:[pkg%s - %s] %O', info.server.item_id, info.server.name, info)
      location.href = `/2023_luck/input/${info.server.item_id}`
    },
    onBasicMenuItemClick(info, idx) {
      // console.log('onBasicMenuItemClick:[%s] %O', `${idx}:${info.title.substring(0, 10)}...`, info)
      location.href = info.url
    }
  },
  filters: {
  }
}</script>

<style scoped lang="scss">
@import "../../../../../sass/commons/commonVariables.scss";

.yealuck-2023-top-base{
  background: #f8edb6;
  h1 {
    margin: 0;
  }
  @include mq('w580'){
    margin-bottom: -50px;
  }
}
.caption{
  font-weight: 600;
  font-size: 15px;
  line-height: 24px;
  text-align: center;
  color: #333233;
  margin: 16px 0;
}
.block-hero_img{
  width: 100%;
}
.block-yearluck-menus_img{
  width: 100%;
}
.yearluck-menu-item{

  width: 100%;
  display:flex;
  align-items:flex-start;
  margin: 0 auto;
  height: 135px;
  background-size: 100%;
  background-repeat: no-repeat;
  cursor: pointer;
  @include mq('w320'){
    height: 162px;
  }
  @include mq('w375'){
    height: 181px;

  }
  @include mq('w580'){
    height: 263px;
  }

}
.yearluck-menu-item_img{
  width: 106px;
  @include mq('w320'){
    width: 130px;
  }
  @include mq('w375'){
    width: 38%;

  }

  @include mq('w580'){
    width: 204px;
  }
}

.menu-title_box_text{
  margin: 0;
  height: 74px;
  overflow: hidden;
  font-size: 13px;
  color: #333233;
  font-weight: 600;
  line-height: 24px;
  @include mq('w320'){
    font-size: 16px;
  }
}


.link-button {
  position: absolute;
  top: -24px;
  right: -32px;
  padding-right: 8px;
  font-size: 19px;
  color: #000;
  background: #c2a358;
  width: 28px;
  height: 28px;
  border-radius: 30px;
  @include mq('w320'){
    right: -5px;
  }
  @include mq('w580'){
    right: -40px;
  }

}
.info-box_title{
  width: 140px;
  display: block;
  margin-top: 10%;
  margin-left: 9px;
  border-bottom: 1px solid #fff;
  padding-bottom: 8px;

  @include mq('w320'){
    width: 163px;


  }

  @include mq('w375'){
    width: 78%;


  }

  @include mq('w580'){
    width: 283px;
    margin-left: 16px;
  }
}
.info-area{

  color: #fff;
  font-size: 10px;
  text-align: right;
  padding-right: 0px;

  position: relative;
  padding-top: 3px;
  @include mq('w320'){
    font-size: 12px;
    padding-top: 3%;
    padding-right: 15%;
  }
  @include mq('w580'){
    font-size: 17px;
    padding-right: 7px;
  }

}
.notice{
  font-size: 10px;
}
.price-wrap {
  display: block;
  font-weight: 600;
}
.block-yearluck-menus{
  padding: 0 20px;
  background: url(/static/img/yearluck/y2023/bg_main.svg) no-repeat;
  background-repeat-y: repeat;
  background-size: 100%;
  padding-bottom: 73px;
}

.block-basic-menus_img{
  width: 100%;
}
.basic-menu-item_thum{
  min-width: 80px;
  width: 80px;
  height: 80px;
  margin-right: 9px;
  @include mq('w320'){
    min-width: 106px;
    width: 106px;
    height: auto;
    margin-right: 9px;
  }

}
.menu-title_box {
  width: 100%;
  position: relative;
}

.block-basic-menus {
  padding: 0 20px;
  margin-top: -73px;
  h2{
    margin-top: 40px;
    line-height: 0;
    margin-bottom: 0;
  }
}
.basic-menu-item {
  background: #fff;
  border-radius: 10px;
  margin-bottom: 8px;
  display: flex;
  padding: 16px;
  cursor: pointer;
}


.btn-take-free-divination {
  background: #fff;
  color: #333233;
  border: 1px solid;
  border-radius: 25px;
  font-size: 14px;
  margin-left: 25%;
  padding: 0 18px;
  line-height: 2em;
  display: block;
  width: 116px;
  height: 32px;
  font-weight:600;
  position: relative;
  padding-left: 10px;
  &::after{
    content:'';
    background: url('/static/img/yearluck/y2023/top/ic_arrow_button.svg') no-repeat;
    position: absolute;
    height: 13px;
    width: 6px;
    top: 9px;
    right: 10px;

  }
  @include mq('w320'){
    margin-left: 40%;
  }
  @include mq('w375'){
    position: absolute;
    right: 4px;
  }
  @include mq('w580'){
    margin-left: 70%;
  }
}

.navbtn-block {
  --pad-bottom: 8px;
  width: 100%;
  margin-top: -72px;
  padding-top: calc(26% + var(--pad-bottom));
  position: relative;

  &.lower{
    margin-top:32px;
    padding-bottom: 24px;
  }

  .btn-wrap {
    padding: 0 20px;
    width: 100%;
    max-width: 580px;
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    padding-bottom: var(--pad-bottom);
    &.floating {
      position: fixed;
      top: auto;
      bottom: 0;
      z-index: 100;
      @include mq('w580') {
        //bottom: 0;
      }
    }
    .navbtn {
      cursor: pointer;
      img {
        display: block;
        width: 100%;
      }
      &.navbtn-yearluck {
        width: 49%;
      }
      &.navbtn-basicmenus {
        width: 49%;
      }
    }
  }
}
</style>

<style>
#app {
  height: 100%;
  overflow: hidden;
}
.nav-footer {
  display: none!important;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2023/Yearluck2023Top.vue